import { createFileRoute } from "@tanstack/react-router";
import { AdminExpensesManagement } from "../../components/admin/AdminExpensesManagement";

export const Route = createFileRoute("/admin/expenses")({
  component: AdminExpensesPage,
});

function AdminExpensesPage() {
  return <AdminExpensesManagement />;
}
